import API, { graphqlOperation } from "@aws-amplify/api";
import secureRequest from "@toothfairy/shared-api/secureAPI";
import client from "@toothfairy/shared-api/src/Common/client";
import AppAuth from "@toothfairy/shared-ui/AppAuthScreen";
import envConfig from "../../../envConfig";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { makeGraphQLRequest } from "..";
const getWorkspacesByUserID = async (userID) => {
  const workspacesAvailable = await makeGraphQLRequest(
    graphqlOperation(queries.workspacesByUser, {
      userID,
    })
  );
  // loop through the workspaces and get the workspace name and id
  const promises = workspacesAvailable?.data?.workspacesByUser?.items?.map(
    (u) =>
      makeGraphQLRequest(
        graphqlOperation(queries.getWorkspace, { id: u?.workspaceID })
      )
  );
  return Promise.all(promises);
};

const createWorkspace = async (object) => {
  try {
    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.createWorkspace, { input: object })
    );
    return response.data.createWorkspace;
  } catch (error) {
    console.error("Error creating Workspace:", error);
    throw error;
  }
};

const updateWorkspace = async (id, args) => {
  try {
    // First, fetch the current version of the Workspace
    const getWorkspaceResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getWorkspace, { id })
    );
    const currentWorkspace = getWorkspaceResponse.data.getWorkspace;

    // Prepare the update input
    const updateInput = { id, _version: currentWorkspace._version };
    args.forEach((arg) => {
      updateInput[arg.property] = arg.value;
    });

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.updateWorkspace, { input: updateInput })
    );
    return response.data.updateWorkspace;
  } catch (error) {
    console.error("Error updating Workspace:", error);
    throw error;
  }
};

const _deleteWorkspace = async (id) => {
  try {
    // First, fetch the current version of the Workspace
    const getWorkspaceResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getWorkspace, { id })
    );
    const currentWorkspace = getWorkspaceResponse.data.getWorkspace;

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.deleteWorkspace, {
        input: { id, _version: currentWorkspace._version },
      })
    );
    return response.data.deleteWorkspace;
  } catch (error) {
    console.error("Error deleting Workspace:", error);
    throw error;
  }
};

const updateWorkspaceUsers = async ({ users, workspaceid }) => {
  const payload = await AppAuth.getCurrentSession();
  const url = `${envConfig.REACT_APP_REST_ENDPOINT}/users/update-workspace-users`;
  const body = {
    users,
    workspaceid,
  };
  return secureRequest(client, "POST", url, null, body, true, null, payload);
};

export default {
  createWorkspace,
  updateWorkspace,
  deleteWorkspace: _deleteWorkspace,
  updateWorkspaceUsers,
  getWorkspacesByUserID,
};
